import React from 'react';
import styled from 'styled-components';
import Slider, { Settings } from 'react-slick';
import Typography from '@material-ui/core/Typography';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

import { useMediaQuery } from '@material-ui/core';
import { BREAKPOINTS } from 'src/utils/constants';
import { IListing } from 'src/interface';
import ListingCard from '../../ListingCard';

const StyledTypography = styled(Typography)`
  margin: 20px 0 !important;
`;
const SliderContainer = styled('div')`
  max-width: 100%;
  margin-bottom: 25px;
  .slick-next,
  .slick-prev {
    &:before {
      color: black;
    }
  }
  .slick-slide {
    padding-bottom: 10px;
  }
  .slick-prev {
    left: -50px !important;
  }
  .slick-next {
    right: -50px !important;
  }
`;
const SliderWrapper = styled('div')`
  //max-width: 80%;
  //margin: 0 auto;
`;
const SliderItem = styled('div')`
  &:focus {
    outline: none;
  }
`;
const StyledListingCard = styled(ListingCard)`
  //max-width: 90%;
  margin: 0 10px;
`;
const ArrowContainer = styled.div`
  box-shadow: rgba(46, 62, 72, 0.12) 0px 0px 2px 0px, rgba(46, 62, 72, 0.12) 0px 2px 4px 0px;
  color: ${({ theme }) => theme.colors.primary} !important;
  border: 1px solid rgba(46, 62, 72, 0.12);
  bottom: 0px;
  height: 40px;
  margin-top: auto;
  margin-bottom: auto;
  position: absolute;
  top: 0px;
  width: 40px;
  z-index: 10;
  background: white !important;
  border-radius: 100% !important;
  display: flex !important;
  justify-content: center;
  align-items: center;
  &:before {
    display: none;
  }
`;
const NextArrow = styled(ArrowForwardIosIcon)`
  position: relative;
  font-size: 13px !important;
  left: 0px;
`;
const PrevArrow = styled(ArrowBackIosIcon)`
  position: relative;
  font-size: 13px !important;
  left: 2px;
`;

type TProps = {
  listings: IListing[];
  className?: string;
  sliderSettings: Settings;
  title: string;
  isWantedListing?: boolean;
};
const CardsSlider = ({ listings, title, sliderSettings, className, isWantedListing }: TProps) => {
  const isMobile = useMediaQuery(BREAKPOINTS.MOBILE);
  const MainSliderSettings = {
    arrows: true,
    dots: false,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    speed: 200,
    centerPadding: '10px',
    className: 'center',
    centerMode: isMobile,
    nextArrow: (
      <ArrowContainer>
        <NextArrow />
      </ArrowContainer>
    ),
    prevArrow: (
      <ArrowContainer>
        <PrevArrow />
      </ArrowContainer>
    ),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          arrows: true,
          dots: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: false,
        },
      },
    ],
  };
  const settings = { ...MainSliderSettings, ...sliderSettings };
  return (
    <SliderContainer className={className}>
      <StyledTypography variant="h4">{title}</StyledTypography>
      <SliderWrapper>
        <Slider {...settings}>
          {listings.map((item, index) => {
            return (
              <SliderItem key={index}>
                <StyledListingCard listingData={item} isWantedListing={isWantedListing} />
              </SliderItem>
            );
          })}
        </Slider>
      </SliderWrapper>
    </SliderContainer>
  );
};

export default CardsSlider;
